import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/` is not a screen.
 *
 * The app's landing place is Home, which lives behind the authenticated shell;
 * an unauthenticated visitor is bounced from there to the entry screen. Keeping
 * the redirect here rather than rendering a public page is what makes
 * US-00-006.16 true at the root: there is no unauthenticated route that returns
 * any record content.
 */
export const Route = createFileRoute("/")({
	beforeLoad: () => {
		// `redirect()` returns a control-flow signal rather than an Error, and
		// throwing it is how TanStack Router is told to redirect. The rule is right
		// in general and wrong here.
		// eslint-disable-next-line @typescript-eslint/only-throw-error
		throw redirect({ to: "/home", replace: true })
	},
})
